(() => {
  const KL_CAROUSEL_SELECTOR = '[data-kl-carousel]';
  const KL_TAB_PANEL_SELECTOR = '[data-kl-tab-panel]';

  function refreshCarousels(panel) {
    panel.querySelectorAll(KL_CAROUSEL_SELECTOR).forEach((carousel) => {
      if (typeof carousel.refreshSlider !== 'function') return;

      try {
        carousel.refreshSlider();
      } catch (error) {
        console.debug('kl-carousel-tab-refresh: could not refresh the carousel', {
          carouselId: carousel.id,
          error,
        });
      }
    });
  }

  function initPanel(panel) {
    if (panel.dataset.klCarouselTabRefreshReady === 'true') return;
    if (!panel.querySelector(KL_CAROUSEL_SELECTOR)) return;

    panel.dataset.klCarouselTabRefreshReady = 'true';

    let wasHidden = panel.hidden;

    const observer = new MutationObserver(() => {
      const isHidden = panel.hidden;

      if (isHidden === wasHidden) return;

      wasHidden = isHidden;

      if (!isHidden) refreshCarousels(panel);
    });

    observer.observe(panel, { attributes: true, attributeFilter: ['hidden'] });
  }

  function initPanels(rootElement) {
    rootElement.querySelectorAll(KL_TAB_PANEL_SELECTOR).forEach(initPanel);
  }

  initPanels(document);

  document.addEventListener('shopify:section:load', (event) => initPanels(event.target));
})();
